export default __webpack_public_path__ + "static/media/lgAll.d8a63827.svg";